import TitleLogo from './TitleLogo'

export default TitleLogo
